module.exports = __webpack_public_path__ + "static/media/atv-kat.14e63544.jpg";